module.exports = __webpack_public_path__ + "static/media/eddezennn.8f210b0d.svg";